import {FC, useState} from 'react'
import {useSearchParams} from 'react-router-dom'
import {setupEmployeePassword} from '../../../config/api'

const EmployeePasswordSetup: FC = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const email = searchParams.get('email') || ''

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (!token || !email) {
      setError('Invalid link. Please use the link from your email.')
      return
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters')
      return
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match')
      return
    }

    setLoading(true)
    try {
      const res = await setupEmployeePassword({token, email, password})
      if (res.status) {
        setSuccess(true)
      } else {
        setError(res.message || 'Failed to set password')
      }
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Failed to set password. The link may have expired.')
    }
    setLoading(false)
  }

  return (
    <div style={{minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'}}>
      <div style={{width: '100%', maxWidth: '460px'}}>
        <div style={{background: '#2E7D32', color: 'white', padding: '24px', borderRadius: '12px 12px 0 0', textAlign: 'center'}}>
          <h1 style={{margin: 0, fontSize: '24px', fontWeight: 'bold'}}>Global Coatings</h1>
          <p style={{margin: '8px 0 0', opacity: 0.9, fontSize: '14px'}}>Employee Password Setup</p>
        </div>

        <div style={{background: 'white', padding: '32px', borderRadius: '0 0 12px 12px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)'}}>
          {success ? (
            <div style={{textAlign: 'center'}}>
              <div style={{fontSize: '48px', marginBottom: '16px'}}>
                <i className='fa fa-check-circle' style={{color: '#2E7D32'}}></i>
              </div>
              <h3 style={{marginBottom: '12px', color: '#333'}}>Password Set Successfully!</h3>
              <p style={{color: '#666', marginBottom: '24px'}}>
                You can now log in to the Global Coatings Employee App with your email and new password.
              </p>
              <div style={{padding: '12px', background: '#f0f0f0', borderRadius: '8px', fontSize: '14px', color: '#555'}}>
                <strong>Email:</strong> {email}
              </div>
            </div>
          ) : (
            <>
              {!token || !email ? (
                <div style={{textAlign: 'center', color: '#d32f2f'}}>
                  <div style={{fontSize: '48px', marginBottom: '16px'}}>
                    <i className='fa fa-exclamation-triangle'></i>
                  </div>
                  <h3>Invalid Link</h3>
                  <p>This password setup link is invalid. Please check your email for the correct link.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <p style={{color: '#666', marginBottom: '20px', fontSize: '14px'}}>
                    Setting password for <strong>{email}</strong>
                  </p>

                  {error && (
                    <div style={{background: '#ffebee', color: '#c62828', padding: '12px', borderRadius: '6px', marginBottom: '16px', fontSize: '14px'}}>
                      <i className='fa fa-exclamation-circle' style={{marginRight: '8px'}}></i>
                      {error}
                    </div>
                  )}

                  <div style={{marginBottom: '16px'}}>
                    <label style={{display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px', color: '#333'}}>
                      New Password
                    </label>
                    <input
                      type='password'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder='Minimum 6 characters'
                      style={{width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box'}}
                    />
                  </div>

                  <div style={{marginBottom: '24px'}}>
                    <label style={{display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px', color: '#333'}}>
                      Confirm Password
                    </label>
                    <input
                      type='password'
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder='Re-enter password'
                      style={{width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box'}}
                    />
                  </div>

                  <button
                    type='submit'
                    disabled={loading}
                    style={{
                      width: '100%',
                      padding: '12px',
                      background: loading ? '#aaa' : '#2E7D32',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      cursor: loading ? 'not-allowed' : 'pointer',
                    }}
                  >
                    {loading ? 'Setting Password...' : 'Set Password'}
                  </button>
                </form>
              )}
            </>
          )}
        </div>

        <div style={{textAlign: 'center', padding: '16px', fontSize: '12px', color: '#999'}}>
          Global Coatings &copy; {new Date().getFullYear()}
        </div>
      </div>
    </div>
  )
}

export {EmployeePasswordSetup}
